import { render, staticRenderFns } from "./integrated.vue?vue&type=template&id=f5d6d97a&"
import script from "./integrated.vue?vue&type=script&lang=js&"
export * from "./integrated.vue?vue&type=script&lang=js&"
import style0 from "./integrated.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports